import i18next from '../i18next';

// export const LEVEL_1 = 'error';
// export const LEVEL_2 = 'warning';
// export const LEVEL_3 = 'info';

export const tokenSeparators = [' ', ',', ';', '、', '/', '，', '；'];

// remove unused code
// export const EMPTYOBJ = Object.freeze({});
// export const EMPTY_ARRAT = [];
//
// export const EXCEPTION_INFO_LIST = {
//   CREATE_STORY: {
//     get info() {
//       return i18next.t('Meego_Shared_Web_Common_ErrorCreatingRequirement');
//     },
//     level: LEVEL_1,
//   },
//   UPDATE_STORY: {
//     get info() {
//       return i18next.t('Meego_Shared_Web_Common_ErrorUpdatingRequirement');
//     },
//     level: LEVEL_1,
//   },
//   UPDATE_STORY_ITEM: {
//     get info() {
//       return i18next.t('Meego_Shared_Web_Common_ErrorUpdatingRequirementInformation');
//     },
//     level: LEVEL_1,
//   },
//   UPDATE_STORY_STAGE: {
//     get info() {
//       return i18next.t('Meego_Shared_Web_Common_ErrorUpdatingDemandNodeInformation');
//     },
//     level: LEVEL_1,
//   },
//   COMPLETE_STEP: {
//     get info() {
//       return i18next.t('Meego_Shared_Web_Common_FailedToCompleteNodeUpdate');
//     },
//     level: LEVEL_1,
//   },
//   DELETE_STORY: {
//     get info() {
//       return i18next.t('Meego_Shared_Web_Common_FailedToDeleteRequirement');
//     },
//     level: LEVEL_1,
//   },
//   DELETE_STORY_STATE: {
//     get info() {
//       return i18next.t('Meego_Shared_Web_Common_FailedToDeleteDemandNode_IcuSupport');
//     },
//     level: LEVEL_1,
//   },
//   ADD_STORY_STATE: {
//     get info() {
//       return i18next.t('Meego_Shared_Web_Common_RecoveryDemandNodeFailed');
//     },
//     level: LEVEL_1,
//   },
//   UPDATE_STORY_STATE_OWNER: {
//     get info() {
//       return i18next.t('Meego_Shared_Web_Common_FailedToUpdateOwnerOfRequiredNode');
//     },
//     level: LEVEL_1,
//   },
//   UPDATE_STORY_STATE_PROPERTY: {
//     get info() {
//       return i18next.t('Meego_Shared_Web_Common_FailedToUpdatePropertiesOfRequiredNode');
//     },
//     level: LEVEL_1,
//   },
//   COMPLETE_QUICK_STEP: {
//     get info() {
//       return i18next.t('Meego_Shared_Web_Common_FailedToQuicklyUpdatePropertiesOfRequiredNodes');
//     },
//     level: LEVEL_1,
//   },
//   UPDATE_STORY_NAME: {
//     get info() {
//       return i18next.t('Meego_Shared_Web_Common_FailedToUpdateNameOfRequirement');
//     },
//     level: LEVEL_1,
//   },
//   MOVE_STORY: {
//     get info() {
//       return i18next.t('Meego_Shared_Web_Common_MobileDemandFailure');
//     },
//     level: LEVEL_1,
//   },
//   EXCEPTION_GLOBAL_COMPONENT: {
//     get info() {
//       return i18next.t('Meego_Shared_Web_Common_GlobalJsException');
//     },
//     level: LEVEL_2,
//   },
// };
//
// export const SCHEDULE_CHANGE_REASONS = [
//   i18next.t('Meego_Shared_Web_Common_UnreasonableEstimateReassessment'),
//   i18next.t('Meego_Shared_Web_Common_TheRelyingPartyIsNotReady'),
//   i18next.t('Meego_Shared_Web_Common_RealizePlanAdjustmentDemandContentAdjustment'),
//   i18next.t('Meego_Shared_Web_Common_ImplementationPlanAdjustmentUeUiDraftAdjustment'),
//   i18next.t('Meego_Shared_Web_Common_AchieveSolutionAdjustmentTechnicalSolutionAdjustment'),
//   i18next.t(
//     'Meego_Shared_Web_Common_RequirementsInsertionPrioritizingTheDevelopmentOfOtherRequirements',
//   ),
//   i18next.t('Meego_Shared_Web_Common_RequirementsInsertionSolvingOnlineHighQualityProblems'),
//   i18next.t('Meego_Shared_Web_Common_PersonnelChange'),
//   i18next.t('Meego_Shared_Web_Common_Other'),
// ];
// export const STATE_DELAY_REASONS = [
//   i18next.t('Meego_Shared_Web_Common_UnreasonableEstimateReassessment'),
//   i18next.t('Meego_Shared_Web_Common_TheRelyingPartyIsNotReady'),
//   i18next.t('Meego_Shared_Web_Common_MissionRequirementsCreationLag'),
//   i18next.t('Meego_Shared_Web_Common_RealizePlanAdjustmentDemandContentAdjustment'),
//   i18next.t('Meego_Shared_Web_Common_ImplementationPlanAdjustmentUeUiDraftAdjustment'),
//   i18next.t('Meego_Shared_Web_Common_AchieveSolutionAdjustmentTechnicalSolutionAdjustment'),
//   i18next.t(
//     'Meego_Shared_Web_Common_RequirementsInsertionPrioritizingTheDevelopmentOfOtherRequirements',
//   ),
//   i18next.t('Meego_Shared_Web_Common_RequirementsInsertionSolvingOnlineHighQualityProblems'),
//   i18next.t('Meego_Shared_Web_Common_Other'),
// ];

export const STORY_ABORT_REASONS = (workObjectName: string) => [
  i18next.t('Meego_Shared_Web_Common_NameCancelDontDoItNow', {
    name: workObjectName,
  }),
  i18next.t('Meego_Shared_Web_Common_NameDuplicateMergeAdvanceWithOthersDoingName', {
    name: workObjectName,
  }),
  i18next.t('Meego_Shared_Web_Common_TestItOut'),
  i18next.t('Meego_Shared_Web_Common_Other'),
];

export const STORY_RESUME_REASONS = (workObjectName: string) => [
  i18next.t('Meego_Shared_Web_Common_NameRestart', {
    name: workObjectName,
  }),
  i18next.t('Meego_Shared_Web_Common_MisoperationFallback'),
  i18next.t('Meego_Shared_Web_Common_TestItOut'),
  i18next.t('Meego_Shared_Web_Common_Other'),
];
// 兼容新老版本重复type
// export const PRE_TEXT = '!@#$_';

export const ISSUE_USER_MAP = /*#__PURE__*/ (() => ({
  get issue_reporter() {
    return i18next.t('Meego_Shared_Web_Common_Rapporteur');
  },
  get issue_operator() {
    return i18next.t('Meego_Shared_Web_Common_Manager');
  },
}))();
// 占位符当前值
export const CURRENT_ASSOCIATE_VALUE = 'current_associate_value';
export const CURRENT_ASSOCIATE_VALUE_NUM = -1;

// 路由隔离名单
export const SIMPLE_NAME_WHITE_LIST = [
  'home',
  'fetchCookieByLogin',
  'loginAsset',
  'switchAsset',
  'noPermission',
  'list',
  'workbench',
  'quick_form',
  'issue_trans',
  'enterprise_manage',
  'feishu_workbench_mobile',
  'openapp',
  'tenant',
  'helpcenter',
  'error-page',
  'light_share',
  'jumpToOuter',
  'issue_create_open',
  'story_create_open',
  'b',
  'new_form',
  'teams',
  'favorites',
  'workspaces',
  'fetch-cookie-by-login',
  'new-form',
  'issue-trans',
  'issue-create-open',
  'story-create-open',
  'jump-to-outer',
  'light-share',
  'login-asset',
  'switch-asset',
];

// appInforProvider 隔离初始化逻辑路由白名单
export const NO_INIT_APP_INFO_WHITE_LIST = [
  '/home',
  '/fetchCookieByLogin',
  '/loginAsset',
  '/enterprise_manage',
  '/enterprise_manage/connect/invite',
  '/noPermission',
  '/meego/fetchCookieByLogin',
  '/login-asset',
  '/fetch-cookie-by-login',
  '/openapp/plugin/dev/m',
  '/openapp/plugin_share'
];

// redirect url 白名单
export const NO_REDIRECT_URL_WHITE_LIST = [
  'fetchCookieByLogin',
  'loginAsset',
  'home',
  'login-asset',
  'fetch-cookie-by-login',
];

export const VIRTUAL_USER_TYPE = 1;

// errorcode 上报接口过滤
export const NO_SEND_ERROR_CODE_PATH_LIST = ['meego/goapi/settings/fg', 'https://tosv.byted.org'];

// 跳过登录检查的pathname
export const SKIP_LOGIN_CHECK: RegExp[] = [
  // home页面
  /^\/home\/?$/,
  /^\/noPermission\/?$/, // 存在 noPermission/... 这种链接吗? 这里先保留,避免出问题
  /^\/noPermission\??/, // noPermission链接中往往会存在query参数, 这里需要匹配一下问号
  // 租户创建页面
  /^\/tenant\/?$/,
  /^\/tenant\/create\/?$/,
  /^\/b\/trial\/start\/?$/,
  /^\/b\/trial\/enable\/?$/,
  /^\/b\/trial\/new\/?$/,
  // 企业互联邀请页面
  /^\/enterprise_manage\/connect\/invite\/?$/,
  // 开平移动端调试 url 落地页
  /^\/openapp\/plugin\/dev\/m(\/.*)?(\?.*)?$/,
  // 插件分享页面
  /^\/openapp\/plugin_share(\/.*)?(\?.*)?$/,
  // 邀请成员落地页
  /^\/b\/coworker-invite\/?$/,
];

// 跳过租户登录检查的pathname
const SKIP_TENANT_LOGIN_CHECK: RegExp[] = /*#__PURE__*/ (() => [
  ...SKIP_LOGIN_CHECK,
  /**
   * 渠道登录页下暂时不能做租户校验,因为有一个 /ids 接口在渠道未登录的情况下会报401的错误码(但这是不应该的);
   * 为了和线上逻辑保持一致,这里先讲这个skip加回来.
   */
  /^\/fetch(CookieByLogin|-cookie-by-login)\/?$/,
])();

// 跳过用户登录状态检查的pathname
// export const SKIP_USER_LOGIN_CHECK: RegExp[] = [...SKIP_TENANT_LOGIN_CHECK];

// 跳过多资产校验路由的pathname
export const SKIP_ASSET_URL_WHITE_LIST: RegExp[] = /*#__PURE__*/ (() => [
  ...SKIP_TENANT_LOGIN_CHECK,
  // 渠道登录页面
  /^\/fetch(CookieByLogin|-cookie-by-login)\/?$/,
  /^\/login(Asset|-asset)\/?$/,
])();
// inbox跳过多资产校验路由的pathname
export const SKIP_INBOX_LOGIN_CHECK: RegExp[] = /*#__PURE__*/ (() => [...SKIP_ASSET_URL_WHITE_LIST])();
// 工作台红点跳过登录检查的pathname
export const SKIP_WORKBENCH_BADGE_LOGIN_CHECK: RegExp[] = /*#__PURE__*/ (() => [
  ...SKIP_INBOX_LOGIN_CHECK,
  /^\/enterprise_manage(\/.*)?$/,
])();
